import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 64px;
  background-color: #fff;
  height: 100%;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;

  ${(props) =>
    props.hideOnSmallDevice &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const RightContainer = styled.div`
  width: 100%;
  padding-left: 20px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const ListItem = styled.div`
  cursor: pointer;
  user-select: none;
  width: 100%;
  color: #555;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  padding: 12px 10px 12px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 21px;
  ${(props) =>
    props.active &&
    css`
      color: #fff;
      background-color: ${colors.green};
      border-color: ${colors.green};
    `}
`;

export const ItemText = styled.li`
  list-style: none;
  padding-left: 5px;
`;

export const Card = styled.div`
  width: 100%;
`;
